// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".legal[data-v-e1e4f7d0]{margin-top:6rem;margin-bottom:6rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
